import * as React from "react";
import { cn } from "@/lib/utils";

// H1 - Hero titles
export const H1 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      "text-4xl leading-tight font-medium tracking-tight",
      className,
    )}
    {...props}
  />
));
H1.displayName = "H1";

// H2 - Section titles
export const H2 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      "text-3xl leading-tight font-medium tracking-[0.15px]",
      className,
    )}
    {...props}
  />
));
H2.displayName = "H2";

// H3 - Subsection titles
export const H3 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      "text-2xl leading-tight font-medium tracking-tight",
      className,
    )}
    {...props}
  />
));
H3.displayName = "H3";

export const H4 = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h4
    ref={ref}
    className={cn(
      "text-sm leading-tight font-medium tracking-tight text-gray-800 md:text-xl md:leading-normal",
      className,
    )}
    {...props}
  />
));
H4.displayName = "H4";
// Body - Main text
export const Body = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-base leading-relaxed font-normal", className)}
    {...props}
  />
));
Body.displayName = "Body";

// BodySmall - Secondary text
export const BodySmall = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm leading-relaxed font-normal", className)}
    {...props}
  />
));
BodySmall.displayName = "BodySmall";

export const BodyXSmall = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-xs leading-relaxed font-normal", className)}
    {...props}
  />
));
BodyXSmall.displayName = "BodyXSmall";

// Lead - Large intro text
export const Lead = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-lg leading-relaxed font-normal", className)}
    {...props}
  />
));
Lead.displayName = "Lead";
